import { StringService as StringHelper } from '@rocheglobal/component-library-dot-com/src/services/string/index';
import React, { createRef, MouseEvent, RefObject, useContext, useRef } from 'react';
import { useTranslation } from '../../hooks/use-translation';
import { SearchList } from '../../view/search-list';
import { Modal } from '../../view/search-list/modal';
import { fetchEventsList, fetchEventsTabs } from '../../view/search-list/queries';
import { RocheAddToCalendar } from './roche-add-to-calendar';
import { handleRocheTeaserClick } from '../../helpers/roche-teaser-tracking';
import { RocheUIButton, RocheUIButtonAppearance, RocheUITeaser, RocheUITeaserLayout } from '@repo/roche-ui';
import { createRocheButtonTrackingObject, handleRocheButtonOnClick } from '../../helpers/roche-button-tracking';
import { DateFormattingService } from '../../services/date-time-formatter';
import { RocheXXTranslationContext } from '../../contexts/translation';

const getCalendarData = (item) => ({
  eventTitle: StringHelper.capitalize(item['Event Title']),
  description: StringHelper.capitalize(item['Event Text'] || ''),
  startDate: item['Start Date'].replace(/\s/, 'T'),
  endDate: item['End Date'].replace(/\s/, 'T'),
});

export const RocheMediaEventsList = ({ slot }: any): JSX.Element => {
  const teaserRefs = useRef<RefObject<HTMLDivElement>[]>([]);

  //translations
  const translations = useContext(RocheXXTranslationContext);
  const buttonLabel = useTranslation('add to calendar');
  const readMoreLabel = useTranslation('read more');

  const teaserOverline = (item) => {
    const startDate = DateFormattingService.formatDate(item['Start Date'] as string | Date, 'dateEvents', translations);
    return `
      ${startDate} ${item.Timezone}${item.Location !== null && item.Location !== '' ? ` | ${item.Location}` : ''}
    `;
  };

  return (
    <SearchList slot={slot} tabName='year' pageName='page' fetchTabs={fetchEventsTabs} fetchList={fetchEventsList}>
      {({ items }) => {
        teaserRefs.current = items.map((_, i) => teaserRefs.current[i] ?? createRef());

        return (
          <>
            {items &&
              items.map((item, index) => (
                <RocheUITeaser
                  ref={teaserRefs.current[index]}
                  key={`${item['Start Date']}-${index}`}
                  slot='left'
                  layout={RocheUITeaserLayout.CARD_C}
                  teaserTitle={StringHelper.capitalize(item['Event Title'])}
                  teaserOverline={teaserOverline(item)}
                  teaserUrl={item.Link}
                  forceAlignLeft={true}
                  primaryButtonText={readMoreLabel}
                  secondaryButton={
                    item['Add to Calendar'] === 'TRUE' && (
                      <Modal
                        slot='secondary-action'
                        trigger={
                          <RocheUIButton
                            appearance={RocheUIButtonAppearance.TERTIARY}
                            leftIcon='calendar'
                            text={StringHelper.capitalize(buttonLabel)}
                            onClick={(clickEvent: MouseEvent) => {
                              const text = StringHelper.capitalize(buttonLabel);
                              const trackingData = createRocheButtonTrackingObject(text);
                              handleRocheButtonOnClick(clickEvent, trackingData);
                            }}
                          />
                        }
                      >
                        <RocheAddToCalendar eventItem={getCalendarData(item)} />
                      </Modal>
                    )
                  }
                  onTeaserClick={(e) => {
                    handleRocheTeaserClick(e, item['Event Title'], item.Link, teaserRefs.current[index]);
                  }}
                />
              ))}
          </>
        );
      }}
    </SearchList>
  );
};
